import React from "react";
import { useLocation, useNavigate } from "react-router";
import BackpackIcon from "src/assets/icons/backpack.svg";
import BellIcon from "src/assets/icons/bell.svg";
import LogoIcon from "src/assets/icons/logoInverted.svg";
import UserIcon from "src/assets/icons/userCircle.svg";
import AddButton from "src/components/Buttons/AddButton";

function BottomTab({ onPress }: { onPress?: () => void }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      id="bottom-tab-container"
      className="md:hidden absolute z-10 bottom-[16px] flex items-center justify-between h-[64px] px-[32px] w-full bg-white rounded-full shadow-lg"
    >
      <button
        id="btn-home"
        onClick={() => navigate("/")}
        aria-label="Navigate to Home"
      >
        <img
          id="icon-home"
          src={LogoIcon}
          className="h-[32px] w-[32px] dark:invert"
          alt="Home Icon"
        />
        {location.pathname === "/dashboard" && (
          <div
            id="indicator-home"
            className="h-[2px] w-[32px] bg-black mt-[8px] absolute"
          />
        )}
      </button>

      <button
        id="btn-trips"
        onClick={onPress}
        aria-label="Navigate to Trips"
      >
        <img
          id="icon-trips"
          src={BackpackIcon}
          className="h-[24px] w-[24px] invert dark:invert-0"
          alt="Trips Icon"
        />
        {location.pathname === "/trips" && (
          <div
            id="indicator-trips"
            className="h-[2px] w-[24px] bg-black mt-[8px] absolute"
          />
        )}
      </button>

      <AddButton
        onClick={onPress}
      />

      <button
        id="btn-notifications"
        onClick={onPress}
        aria-label="Navigate to Notifications"
      >
        <img
          id="icon-notifications"
          src={BellIcon}
          className="h-[24px] w-[24px] invert dark:invert-0"
          alt="Notifications Icon"
        />
        {location.pathname === "/notifications" && (
          <div
            id="indicator-notifications"
            className="h-[2px] w-[24px] bg-black mt-[8px] absolute"
          />
        )}
      </button>

      <button
        id="btn-profile"
        onClick={onPress}
        aria-label="Navigate to Profile"
      >
        <img
          id="icon-profile"
          src={UserIcon}
          className="h-[24px] w-[24px] invert dark:invert-0"
          alt="Profile Icon"
        />
        {location.pathname === "/profile" && (
          <div
            id="indicator-profile"
            className="h-[2px] w-[24px] bg-black mt-[8px] absolute"
          />
        )}
      </button>
    </div>
  );
}

export default BottomTab;
